<template>
	<AppDialog disableMaxWidth :dialogName="dialogName" width="750">
		<div v-if="!project">No space found</div>
		<template v-else>
			<div class="content-wrapper pt-4 pb-7 px-9">
				<div class="header">{{ this.project.title }}</div>
				<AppTabs class="pt-7" :tabItems="tabItems" />
			</div>
		</template>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import GeneralTab from './tabs/GeneralTab.vue';
import CollaboratorsTab from './tabs/CollaboratorsTab.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { projectPermissions } from '@/store/modules/projects/getters';
import { setProjectPermissions } from '@/store/modules/projects/actions';
import { mapActions, mapGetters } from 'vuex';
import { getDataCallActionFallback } from '@/utils/store-data-fetcher-service';
import ProjectService from '@/utils/projects-service';
export default {
	name: 'ProjectSettingsDialog',
	props: {
		project: { type: Object },
		dialogPromiseHandlers: { type: Object },
	},
	components: {
		AppDialog,
	},
	computed: {
		...mapGetters([projectPermissions.fullPath]),
		tabItems() {
			const tabs = [
				{ tab: 'General', title: 'General', component: GeneralTab, props: { project: this.project }, disabled: false },
				{
					tab: 'Collaborators',
					title: 'Collaborators',
					component: CollaboratorsTab,
					props: { project: this.project },
					disabled: ProjectService.isPersonalProject(this.project),
				},
			];
			return tabs.filter((x) => !x.disabled);
		},
	},
	methods: {
		...mapActions([setProjectPermissions.fullPath]),
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
	async mounted() {
		await getDataCallActionFallback(this[projectPermissions.fullPath], [this.project?.id], this[setProjectPermissions.fullPath], [
			{ projectId: this.project?.id },
		]);
	},
	data: () => ({
		dialogName: 'ProjectSettingsDialog',
	}),
};
</script>

<style scoped lang="scss">
.content-wrapper {
	height: 710px;
	.header {
		font-size: 18px;
		font-weight: bold;
	}
}
</style>
